/* Sacly — səbət və UI qarşılıqlı əməliyyatları. Temadan asılı deyil. */
(function () {
  if (window.__saclyInit) return;
  window.__saclyInit = true;

  var D = document;

  function toast(html, kind) {
    var old = D.getElementById('sacly-toast');
    if (old) old.remove();
    var el = D.createElement('div');
    el.id = 'sacly-toast';
    el.setAttribute('role', 'status');
    el.setAttribute('aria-live', 'polite');
    el.style.cssText = [
      'position:fixed', 'left:50%', 'transform:translate(-50%,14px)',
      'bottom:calc(env(safe-area-inset-bottom,0px) + 88px)', 'z-index:10000',
      'max-width:min(460px,calc(100vw - 28px))', 'box-sizing:border-box',
      'display:flex', 'align-items:center', 'gap:12px',
      'padding:13px 17px', 'border-radius:14px',
      'font:600 14.5px/1.45 Inter,system-ui,sans-serif',
      'background:' + (kind === 'err' ? '#B23B2E' : '#251C19'), 'color:#FBF7F1',
      'box-shadow:0 10px 34px rgba(37,28,25,.30)',
      'opacity:0', 'transition:opacity .22s ease, transform .22s ease'
    ].join(';');
    el.innerHTML = html;
    D.body.appendChild(el);
    requestAnimationFrame(function () {
      el.style.opacity = '1';
      el.style.transform = 'translate(-50%,0)';
    });
    setTimeout(function () {
      el.style.opacity = '0';
      el.style.transform = 'translate(-50%,14px)';
      setTimeout(function () { el.remove(); }, 260);
    }, 4600);
  }

  function addToCart(items) {
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    return fetch(root + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: items })
    }).then(function (r) {
      if (!r.ok) return r.text().then(function (t) { throw new Error(t || r.status); });
      return r.json();
    });
  }

  function bumpCartCount(added) {
    D.querySelectorAll('[data-cart-count], .cart-count, .cart-count-bubble span:first-child')
      .forEach(function (n) {
        var cur = parseInt((n.textContent || '').replace(/[^0-9]/g, ''), 10);
        if (!isNaN(cur)) n.textContent = String(cur + added);
      });
    D.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
    D.dispatchEvent(new CustomEvent('cart:build', { bubbles: true }));
  }

  D.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-sacly-atc]');
    if (!btn) return;
    e.preventDefault();

    var id = btn.getAttribute('data-variant-id');
    if (!id || id === 'null') { toast('Çalar seçilməyib. Zəhmət olmasa çalar seçin.', 'err'); return; }

    var qty = parseInt(btn.getAttribute('data-qty') || '1', 10) || 1;
    var go = btn.getAttribute('data-go') || '';
    var keep = btn.innerHTML;

    btn.classList.add('is-loading');
    btn.setAttribute('aria-busy', 'true');

    addToCart([{ id: Number(id), quantity: qty }]).then(function () {
      if (go === 'checkout') { window.location.href = '/checkout'; return; }
      if (go === 'cart') { window.location.href = '/cart'; return; }
      btn.classList.remove('is-loading');
      btn.removeAttribute('aria-busy');
      btn.innerHTML = keep;
      bumpCartCount(qty);
      toast('Səbətə əlavə olundu ✓ &nbsp;<a href="/cart" style="color:#EBD9B6;text-decoration:underline">Səbətə keç</a>');
    }).catch(function () {
      btn.classList.remove('is-loading');
      btn.removeAttribute('aria-busy');
      btn.innerHTML = keep;
      toast('Səbətə əlavə etmək alınmadı. Yenidən cəhd edin və ya 077 777 77 78 nömrəsinə zəng edin.', 'err');
    });
  });

  D.addEventListener('change', function (e) {
    var inp = e.target.closest('[data-sacly-shade]');
    if (!inp || !inp.checked) return;
    var scope = inp.closest('[data-sacly-scope]') || D;
    var vid = inp.getAttribute('data-variant-id');
    scope.querySelectorAll('[data-sacly-atc]').forEach(function (b) {
      b.setAttribute('data-variant-id', vid);
    });
  });

  D.addEventListener('click', function (e) {
    var b = e.target.closest('[data-sacly-qty]');
    if (!b) return;
    e.preventDefault();
    var wrap = b.closest('.sacly-qty');
    var inp = wrap && wrap.querySelector('input');
    if (!inp) return;
    var step = b.getAttribute('data-sacly-qty') === 'up' ? 1 : -1;
    var v = (parseInt(inp.value, 10) || 1) + step;
    if (v < 1) v = 1;
    if (v > 20) v = 20;
    inp.value = v;
    inp.dispatchEvent(new Event('change', { bubbles: true }));
  });

  D.addEventListener('change', function (e) {
    var inp = e.target.closest('.sacly-qty input');
    if (!inp) return;
    var scope = inp.closest('[data-sacly-scope]') || D;
    var v = parseInt(inp.value, 10) || 1;
    if (v < 1) { v = 1; inp.value = 1; }
    scope.querySelectorAll('[data-sacly-atc]').forEach(function (b) { b.setAttribute('data-qty', v); });
    recalc(scope);
  });

  function recalc(scope) {
    var box = scope.querySelector('[data-sacly-total]');
    if (!box) return;
    var unit = parseFloat(box.getAttribute('data-unit') || '0');
    var qtyIn = scope.querySelector('.sacly-qty input');
    var qty = qtyIn ? (parseInt(qtyIn.value, 10) || 1) : 1;
    var ship = 0;
    var sel = scope.querySelector('[data-sacly-ship]');
    if (sel) {
      var o = sel.options[sel.selectedIndex];
      ship = parseFloat((o && o.getAttribute('data-price')) || '0');
    }
    var total = unit * qty + ship;
    box.textContent = total.toFixed(2).replace('.', ',') + ' ₼';
  }

  D.addEventListener('change', function (e) {
    if (!e.target.closest('[data-sacly-ship]')) return;
    recalc(e.target.closest('[data-sacly-scope]') || D);
  });

  D.addEventListener('input', function (e) {
    var r = e.target.closest('[data-sacly-ba]');
    if (!r) return;
    var box = r.closest('.sacly-ba__box');
    if (box) box.style.setProperty('--sacly-ba-pos', r.value + '%');
  });

  function initSticky() {
    var bar = D.querySelector('[data-sacly-sticky]');
    if (!bar) return;
    D.body.classList.add('sacly-has-sticky');
    var mark = D.querySelector('.sacly-hero') || D.querySelector('.sacly-section');
    if (!mark) { bar.classList.add('is-on'); return; }
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (ents) {
        bar.classList.toggle('is-on', !ents[0].isIntersecting);
      }, { rootMargin: '-120px 0px 0px 0px' }).observe(mark);
    } else {
      bar.classList.add('is-on');
    }
  }

  function boot() {
    D.querySelectorAll('[data-sacly-scope]').forEach(recalc);
    initSticky();
  }
  if (D.readyState === 'loading') D.addEventListener('DOMContentLoaded', boot);
  else boot();
  D.addEventListener('shopify:section:load', boot);
})();